import React, { useState, useEffect } from 'react';
import { getHandicap } from '../utils/Utilities';

function UserDisplay({User}){

    const [hasUser, setHasUser] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [userFullName, setUserFullName] = useState('');
    const [userGender, setUserGender] = useState('NA');
    const [userHandedness, setUserHandedness] = useState('NA');
    const [userHandicap, setUserHandicap] = useState(-9999);

    useEffect(() => {

        const userAvailable = User !== null;

        setHasUser(userAvailable);
        if(userAvailable){
            setUserEmail(User.id);
            setUserFullName(User.FullName);
            setUserGender(User.Gender);
            setUserHandedness(User.Handedness);
            setUserHandicap(User.Handicap);
        }
        

        return () => {
            //cleanup here
            setHasUser(false);
            setUserEmail('');
            setUserFullName('');
            setUserGender('NA');
            setUserHandedness('NA');
            setUserHandicap(9999);
        };
    },[User]);

    return(
<div>
    {hasUser && (
    <div>
        <div>
            {userEmail}
        </div>
        <div>
            {userFullName}
        </div>
        {/* <div>
            {userGender}
        </div>
        <div>
            {userHandedness}
        </div>
        <div>
            {getHandicap(userHandicap)}
        </div> */}
    </div>
    )}
    
    {!hasUser && (
        <div>
            No user selected.
        </div>
    )}
</div>
    );
}

export default UserDisplay;